import { generateHTML } from '@tiptap/core'
import { createBlogRenderExtensions } from './blogRenderExtensions'

const extensions = createBlogRenderExtensions()

export const tiptapJsonToHtml = (content) => {
  if (!content || typeof content !== 'object') return ''
  try {
    return generateHTML(content, extensions)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[Blog] generateHTML failed', err)
    return ''
  }
}
